export enum PillOptions {
  Below30Days = '< 30 days',
  Between30To60Days = '30-60 days',
  Between60To180Days = '61-180 days',
  Over25 = '>0.25',
  Over50 = '>0.5',
}
